import React from "react";
import "./index.scss";

const FloatingButton = () => {
	return (
		<a
			className="floating-button"
			target="_blank"
			href="https://api.whatsapp.com/send?phone=573174301327"
			rel="noopener noreferrer"
		>
			<em className="fab fa-whatsapp" />
		</a>
	);
};

export default FloatingButton;
